import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorModel, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { TermsAndConditionsResponse } from './uig-legal.model';

@Injectable()
export class UigLegalAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  termsAndConditionsAccept(userId: string): Observable<TermsAndConditionsResponse | ErrorModel> {
    return this.http.post<TermsAndConditionsResponse>(
      this.occEndpoints.buildUrl('termsAndConditionsAccept', {urlParams: { userId }}),
      null
    );
  }

  termsAndConditionsDecline(userId: string): Observable<TermsAndConditionsResponse | ErrorModel> {
    return this.http.post<TermsAndConditionsResponse>(
      this.occEndpoints.buildUrl('termsAndConditionsDecline', {urlParams: { userId }}),
      null
    );
  }
}
